export default __webpack_public_path__ + "static/media/orange_AA.58d9beb2.svg";